<template>
    <re-navbar-top
        v-bind:is-user-authenticated="isUserAuthenticated"
        v-bind:config="config"
        v-bind:navbar-items="navbarItems"
        v-bind:route-name="routeName"
        v-bind:title="title"
        v-on:onLogout="logout"
        v-on:onGotoPortal="gotoPortal"
    >
    </re-navbar-top>
</template>

<script>
import { deleteAllRepowerCookies } from "../../shared/SecurityUtils";
import ReNavbarTop from "../ReNavbarTop/ReNavbarTop";

/**
 * Repower Header.
 * It containts logo, application navigation bar and ReMenu.
 * @displayName ReHeader
 */
export default {
    name: "ReHeader",
    props: {
        /**
         * A boolean that says if a user is authenticated.
         * If you use vuex-oidc library you can pass the "oidcIsAuthenticated" getter
         */
        isUserAuthenticated: {
            type: Boolean,
            required: true,
            default: false,
        },
        /**
         * The menu configuration object.
         * See ReMenu documentation.
         * Properties required:
         * - username: {string} the username displayed in the menu (EG: "matteo.galli") - NOT USED ANYMORE
         * - accessToken: {string} the access token used as API Bearer token while communicatin with apiMiPortal - NOT USED ANYMORE
         * - apiServerPrefix: {string} the URL of the API server (EG: "https://rbmidde02.corp.repower.com/Api") - NOT USED ANYMORE
         * - environmentName: {string} the current environment name. Must be one of: ["development", "integration", "staging", "production"] - MANDATORY
         * - showPortalLink: {boolean} if true show the "Menu" icon - OPTIONAL
         */
        config: {
            type: Object,
            required: true,
        },
        /**
         * The configuration for the application menu (optional).
         * Must be and array of object, for example:
         * {
         *     id: "power",
         *     name: "Power Page",
         *     routeName: "power"
         * }
         */
        navbarItems: {
            type: Array,
            required: false,
        },
        /**
         * A string representing the current route.
         * It should match one of: navbarItems[i].routeName
         */
        routeName: {
            type: String,
            required: false,
        },
        /**
         * A {string} representing the title near the burger menu.
         */
        title: {
            type: String,
            required: false,
        },
    },
    data: () => ({
        isMenuActive: false,
    }),
    components: {
        ReNavbarTop,
    },
    computed: {},
    methods: {
        onReMenuActive(val) {
            this.isMenuActive = val;
        },
        logout() {
            // delete cookies
            deleteAllRepowerCookies();
            // emit event
            this.$emit("onLogout");
        },
        async gotoPortal() {
            const userConfirm = await this.$bvModal.msgBoxConfirm("You are going to exit this application", {
                title: "Are you sure?",
                size: "sm",
                buttonSize: "sm",
                okVariant: "danger",
                okTitle: "Yes",
                cancelTitle: "No",
                footerClass: "p-2",
                hideHeaderClose: false,
                centered: true,
            });
            if (userConfirm) {
                window.location.href = "/mi-portal";
            }
        },
    },
};
</script>

<style lang="css" scoped></style>
